import {
  SkeletonPage,
  Layout,
  SkeletonBodyText,
  Card,
  SkeletonDisplayText,
} from "@shopify/polaris";

function EmptyLoading() {
  return (
    <SkeletonPage>
      <Layout>
        <Layout.Section>
          <SkeletonDisplayText size="medium" />
          <Card>
            <SkeletonBodyText />
          </Card>
        </Layout.Section>
        <Layout.Section>
          <SkeletonDisplayText size="medium" />
          <Card>
            <SkeletonBodyText />
          </Card>
        </Layout.Section>
        <Layout.Section>
          <SkeletonDisplayText size="medium" />
          <Card>
            <SkeletonBodyText />
          </Card>
        </Layout.Section>
      </Layout>
    </SkeletonPage>
  );
}

export default EmptyLoading;
